import React from 'react'
import { Typography, Spin, Carousel } from 'antd'
import moment from 'moment'
import {
    BrowserRouter as Router,
    Link,
    Route
} from 'react-router-dom'
import { changeFormatdate } from '../../../utils/formatdate'

const { Text, Title } = Typography
class NewsPage extends React.PureComponent {
    state = {
        headpost: null,
    }

    renderBox = (picbanner) => {
        return (
            <img src={picbanner} />
        )
    }

    render() {
        const readmoreText = "อ่านต่อ >>"
        const { picbanner, readmore, headpost } = this.props
        return (
            <>
                {headpost &&
                    <div>
                        <Carousel
                            autoplay
                            dots={false}
                        >
                            {/* {this.renderBox(headpost.bannerLink)} */}
                        </Carousel>
                        <div className="pt-4" >
                            <Title level={4} className=" mb-0" >{headpost.postTitleTH}</Title>
                            <div className="pt-1" >
                                <Text className="color-orange" style={{ fontSize: 14 }} >{changeFormatdate(headpost.date)}</Text><br />
                            </div>
                            <div className="pt-3" >
                                <Text className="" style={{ fontSize: 12 }} >{headpost.subTitleTH}</Text><br />
                            </div>
                            <div className="pt-3" >
                                <Link
                                    to={{
                                        pathname: '/news/detailnews/' + headpost.postId,
                                        state: {
                                            news: { headpost }
                                        }
                                    }}>
                                    <Text className="color-orange" style={{ fontSize: '12' }} >{readmoreText}</Text>
                                </Link>
                            </div>
                        </div>
                        <hr className="mt-4" />
                    </div>
                    ||
                    <>
                        <div style={{textAlign:"center"}}>
                            <Text className="color-gray" >ไม่พบข้อมูล</Text>
                        </div>
                        <hr className="mt-4" />
                    </>
                } 

            </>
        )
    }
}

export default NewsPage
